// extracted by mini-css-extract-plugin
export default {"open":"DevTools_open__MfCnT"};